import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { DadosConta } from '../models/dados-conta';

@Injectable({
  providedIn: 'root'
})
export class DadosContaApiService extends ApiService {

  private readonly baseUrlRoute = 'dados-conta';

  constructor(http: HttpClient) {
    super(http);
  }

  public obterDadosConta(): Observable<DadosConta> {
    return this.get<DadosConta>(`/${this.baseUrlRoute}`);
  }

  public editarDados(email: string): Observable<void> {
    return this.patch<void>(`/${this.baseUrlRoute}`, undefined, { email });
  }

  public trocarSenha(senhaAtual: string, novaSenha: string): Observable<void> {
    return this.patch<void>(`/${this.baseUrlRoute}/senha`, undefined, { senhaAtual, novaSenha });
  }
}
